import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/github/workspace/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const DiscoverBlock = makeShortcode("DiscoverBlock");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h2 {...{
      "id": "overview"
    }}>{`Overview`}</h2>
    <p>{`Welcome to the Creative Cloud Libraries API! Before jumping straight into the documentation, we recommend taking a moment to learn more about what Libraries are and what the API can do for you.`}</p>
    <DiscoverBlock slots="link, text" mdxType="DiscoverBlock" />
    <p><a parentName="p" {...{
        "href": "/creative-cloud-libraries/docs/overview/product-overview/"
      }}>{`What are Creative Cloud Libraries?`}</a></p>
    <p>{`If you're new to Creative Cloud Libraries, get started by having a look at this service from the user perspective.`}</p>
    <DiscoverBlock slots="link, text" mdxType="DiscoverBlock" />
    <p><a parentName="p" {...{
        "href": "/creative-cloud-libraries/docs/overview/sample-libraries/"
      }}>{`Sample libraries`}</a></p>
    <p>{`Need some sample Library content to experiment with? Try these public Libraries.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      